module.exports = new __parcel__URL__("Hiring Process.1a46f9b1.svg").toString();